<template>
  <div>
    <template v-for="c in CONTEXTS">
      <slot :name="c" v-if="contextIs(c)"></slot>
    </template>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";

  const CONTEXTS: string[] = ['simple', 'workarea'];

  export default Vue.extend({
    props: {
      context: {
        type: String as () => typeof CONTEXTS[number],
        default: null,
      },
    },
    data: function () {
      return {
        CONTEXTS,
      };
    },
    methods: {
      contextIs(context: typeof CONTEXTS[number]): boolean {
        return this.context === context;
      },
    },
  });
</script>
